module.exports = __webpack_public_path__ + "static/img/e10-cover.fdfd94cc.png";